import { render, staticRenderFns } from "./LavorazioneViaggioArrivo.vue?vue&type=template&id=9b9f5ba4&scoped=true&"
import script from "./LavorazioneViaggioArrivo.vue?vue&type=script&lang=js&"
export * from "./LavorazioneViaggioArrivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9f5ba4",
  null
  
)

export default component.exports